// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   Grid,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";
// import {
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import MainCard from "ui-component/cards/MainCard";
// import { gridSpacing } from "store/constant";
// import { useDebounce } from "hooks/useDebounced";

// const PASS_STATUS = {
//   PENDING: "pending",
//   ACCEPTED: "accept",
//   REJECTED: "reject",
// };

// export default function VehicleGatePassApproval() {
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // ✅ Fetch staff's submitted gate passes
//   const fetchStaffGatePasses = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}staff/all-vehicle-gatepass?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         setRows(result.data.vehicleGatePasses || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch gate passes");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching gate passes:", error);
//       toast.error("Something went wrong while fetching gate passes");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchStaffGatePasses();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   // ✅ Pagination
//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // ✅ Update staff status
//   const updateStaffStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;

//     const actionText = newStatus === PASS_STATUS.ACCEPTED ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this gate pass?`,
//       icon: newStatus === PASS_STATUS.ACCEPTED ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === PASS_STATUS.REJECTED,
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}update-staff-vehicle-gatepass-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success(`Gate Pass ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, staff_status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} gate pass`);
//         }
//       } catch (error) {
//         console.error("Error updating staff status:", error);
//         toast.error("Something went wrong while updating gate pass");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // ✅ Status chip UI
//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search gate passes..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Name, company..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">Vehicle Gate Pass Approvals ({total} total)</Typography>
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="gate pass table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>Gate Pass ID</TableCell>
//                     <TableCell>Driver Name</TableCell>
//                     <TableCell>Vehicle</TableCell>
//                     <TableCell>Company</TableCell>
//                     <TableCell>Department</TableCell>
//                     <TableCell>Email</TableCell>
//                     <TableCell>Entry Time</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>No gate passes found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold" color="primary">
//                             {row.visitorId}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold">
//                             {row.fullName || "N/A"}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2">
//                             {row.vehicleName} - {row.vehiclePlateNo}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{row.companyName || "N/A"}</TableCell>
//                         <TableCell>{row.department?.name || "N/A"}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{row.email}</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="caption" display="block">
//                             From: {formatDate(row.visitStart)}
//                           </Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             To: {formatDate(row.visitEnd)}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             {row.status === PASS_STATUS.PENDING &&
//                               row.staff_status === PASS_STATUS.PENDING ? (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateStaffStatus(
//                                         row._id,
//                                         PASS_STATUS.ACCEPTED,
//                                         row.visitors?.[0]?.fullName || "Visitor"
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateStaffStatus(
//                                         row._id,
//                                         PASS_STATUS.REJECTED,
//                                         row.visitors?.[0]?.fullName || "Visitor"
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             ) : row.staff_status === PASS_STATUS.ACCEPTED ? (
//                               <Typography variant="body2" color="success.main">
//                                 ✅ Accepted by You
//                               </Typography>
//                             ) : row.staff_status === PASS_STATUS.REJECTED ? (
//                               <Typography variant="body2" color="error.main">
//                                 ❌ Rejected by You
//                               </Typography>
//                             ) : row.status !== PASS_STATUS.PENDING ? (
//                               <Typography variant="body2" color="error.main">
//                                 ⚠️ Admin already{" "}
//                                 {row.status === PASS_STATUS.ACCEPTED ? "accepted" : "rejected"} this
//                                 request
//                               </Typography>
//                             ) : null}
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }

import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  TextField,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import MainCard from "ui-component/cards/MainCard";
import { gridSpacing } from "store/constant";
import { useDebounce } from "hooks/useDebounced";

const PASS_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accept",
  REJECTED: "reject",
};

export default function VehicleGatePassApproval() {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});

  const debouncedSearch = useDebounce(search, 1000);

  // ✅ Fetch staff's submitted gate passes
  const fetchStaffGatePasses = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}staff/all-vehicle-gatepass?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.code === 200) {
        setRows(result.data.vehicleGatePasses || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("gatePass.fetchError"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching gate passes:", error);
      toast.error(t("gatePass.fetchErrorGeneric"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffGatePasses();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  // ✅ Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // ✅ Update staff status
  const updateStaffStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    const actionText = newStatus === PASS_STATUS.ACCEPTED ? t("gatePass.accept") : t("gatePass.reject");

    swal({
      title: `${actionText} ${name}?`,
      text: t("gatePass.confirmAction", { action: actionText.toLowerCase() }),
      icon: newStatus === PASS_STATUS.ACCEPTED ? "success" : "error",
      buttons: [t("gatePass.cancel"), actionText],
      dangerMode: newStatus === PASS_STATUS.REJECTED,
    }).then(async (willProceed) => {
      if (!willProceed) return;

      try {
        setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}update-staff-vehicle-gatepass-status/${id}`,
          {
            method: "PUT",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ status: newStatus }),
          }
        );

        const result = await response.json();

        if (result.code === 200) {
          toast.success(t("gatePass.actionSuccess", { action: actionText }));
          setRows((prev) =>
            prev.map((item) => (item._id === id ? { ...item, staff_status: newStatus } : item))
          );
        } else {
          toast.error(result.message || t("gatePass.actionError", { action: actionText.toLowerCase() }));
        }
      } catch (error) {
        console.error("Error updating staff status:", error);
        toast.error(t("gatePass.updateError"));
      } finally {
        setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
      }
    });
  };

  // ✅ Status chip UI
  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { color: "warning", icon: <PendingIcon />, label: t("gatePass.status.pending") },
      accept: { color: "success", icon: <AcceptIcon />, label: t("gatePass.status.accepted") },
      reject: { color: "error", icon: <RejectIcon />, label: t("gatePass.status.rejected") },
    };
    const config = statusConfig[status] || statusConfig.pending;

    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("gatePass.searchLabel")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("gatePass.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("gatePass.statusFilter")}</InputLabel>
            <Select value={statusFilter} onChange={handleStatusFilter} label={t("gatePass.statusFilter")}>
              <MenuItem value="all">{t("gatePass.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("gatePass.status.pending")}</MenuItem>
              <MenuItem value="accept">{t("gatePass.status.accepted")}</MenuItem>
              <MenuItem value="reject">{t("gatePass.status.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">
                {t("gatePass.title")} ({total} {t("gatePass.total")})
              </Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="gate pass table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("gatePass.table.sno")}</TableCell>
                    <TableCell>{t("gatePass.table.gatePassId")}</TableCell>
                    <TableCell>{t("gatePass.table.driverName")}</TableCell>
                    <TableCell>{t("gatePass.table.vehicle")}</TableCell>
                    <TableCell>{t("gatePass.table.company")}</TableCell>
                    <TableCell>{t("gatePass.table.department")}</TableCell>
                    <TableCell>{t("gatePass.table.email")}</TableCell>
                    <TableCell>{t("gatePass.table.entryTime")}</TableCell>
                    <TableCell>{t("gatePass.table.status")}</TableCell>
                    <TableCell align="center">{t("gatePass.table.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("gatePass.loading")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("gatePass.noData")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            {row.visitorId}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {row.fullName || t("gatePass.na")}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {row.vehicleName} - {row.vehiclePlateNo}
                          </Typography>
                        </TableCell>
                        <TableCell>{row.companyName || t("gatePass.na")}</TableCell>
                        <TableCell>{row.department?.name || t("gatePass.na")}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{row.email}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" display="block">
                            {t("gatePass.from")}: {formatDate(row.visitStart)}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {t("gatePass.to")}: {formatDate(row.visitEnd)}
                          </Typography>
                        </TableCell>
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            {row.status === PASS_STATUS.PENDING &&
                              row.staff_status === PASS_STATUS.PENDING ? (
                              <>
                                <Tooltip title={t("gatePass.accept")}>
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() =>
                                      updateStaffStatus(
                                        row._id,
                                        PASS_STATUS.ACCEPTED,
                                        row.visitors?.[0]?.fullName || t("gatePass.visitor")
                                      )
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    {updatingStatus[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <AcceptIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title={t("gatePass.reject")}>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      updateStaffStatus(
                                        row._id,
                                        PASS_STATUS.REJECTED,
                                        row.visitors?.[0]?.fullName || t("gatePass.visitor")
                                      )
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    <RejectIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : row.staff_status === PASS_STATUS.ACCEPTED ? (
                              <Typography variant="body2" color="success.main">
                                ✅ {t("gatePass.acceptedByYou")}
                              </Typography>
                            ) : row.staff_status === PASS_STATUS.REJECTED ? (
                              <Typography variant="body2" color="error.main">
                                ❌ {t("gatePass.rejectedByYou")}
                              </Typography>
                            ) : row.status !== PASS_STATUS.PENDING ? (
                              <Typography variant="body2" color="error.main">
                                ⚠️ {t("gatePass.adminAction", {
                                  action: row.status === PASS_STATUS.ACCEPTED ? t("gatePass.accepted").toLowerCase() : t("gatePass.rejected").toLowerCase()
                                })}
                              </Typography>
                            ) : null}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}